// extracted by mini-css-extract-plugin
export default {"controlHome":"SlideButton_controlHome__EmGdL","controlArmy":"SlideButton_controlArmy__grbJs"};